import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { AuthService } from '../services/auth.service';
import { BuyCoinService } from '../services/buy-coin.service';
import { CommonService } from '../services/common.service';
import { TransactionService } from '../services/transaction.service';

@Component({
  selector: 'app-buy-coins',
  templateUrl: './buy-coins.component.html',
  styleUrls: ['./buy-coins.component.css']
})
export class BuyCoinsComponent implements OnInit {

  sources
  sourceAmount
  selectedSource
  titleUrl
  title
  fees
  destinations = []
  selectedDestination
  convertedAmount
  title1Url
  title1
  conversionRate
  totalAmountToBePaid
  psiForm : FormGroup
  psiUrl 
  storeKeyPsi 
  userEmail
  transactionId

  constructor(private buyCoinService : BuyCoinService, private transactionService : TransactionService, private commonService : CommonService, private authService : AuthService) { }

  ngOnInit(): void {
    this.psiUrl = environment.PSI_FORM_URL
    this.storeKeyPsi = environment.PSI_STORE_KEY_CC
    this.userEmail = this.authService.user.email
    if(this.transactionService.connectedWalletAddress){
      this.transactionService.disconnectWallet()
    }
    this.getBuyingCurrencies()
    this.getStableCurrencies()
  }

  selectSource(source){
    this.selectedSource = source
    this.title = source.Name
    this.titleUrl = source.icon.url
    this.resetInput()
    if(this.selectedSource && this.selectedDestination){
      this.getTransactionFees()
      this.getExchangeRate()
    }
  }

  selectDestination(destination){
    this.selectedDestination = destination
    this.transactionService.selectedSource = destination
    this.title1 = destination.name
    this.title1Url = destination.image.url
    this.resetInput()
    if(this.selectedSource && this.selectedDestination){
      this.getTransactionFees()
      this.getExchangeRate()
    }
  }

  changeDestinationAmount(){
    this.convertedAmount = this.conversionRate * this.sourceAmount
    this.totalAmountToBePaid = this.sourceAmount + this.fees
  }

  getBuyingCurrencies(){
    this.buyCoinService.getBuyCurrencies().subscribe(res => {
      this.sources = res
    })
  }

  getStableCurrencies(){
    this.buyCoinService.getDestinationCurrencies().subscribe((res:any) => {
      res.forEach((currency:any) => {
        if(currency.buyEnabled){
          this.destinations.push(currency)
        }
      })
    }, (err : any) => [
      console.log(err)
    ])
  }

  getExchangeRate(){
    this.buyCoinService.getBuyRates(this.selectedSource.id, this.selectedDestination.id).subscribe((res:any) => {
      this.conversionRate = res[0].rate
    }, (err:any) => {
      console.log(err)
    })
  }

  getTransactionFees(){
    this.buyCoinService.getBuyFees(this.selectedSource.id, this.selectedDestination.id).subscribe((res:any) => {
      this.fees = res[0].fee
    }, (err:any) => {
      console.log(err)
    })
  }

  resetInput(){
    this.sourceAmount = 0
    this.convertedAmount = 0
  }

  checkPaybutton(){
    if(!this.sourceAmount || !this.convertedAmount || !this.selectedDestination || !this.selectedSource || !this.transactionService.connectedWalletAddress){
      return true
    }
    else{
      return false
    }
  }
  
  postTransaction(){
    let buyTransObject = {
      recaddress: this.transactionService.connectedWalletAddress,
      feeamount: this.fees,
      srcamount: this.convertedAmount,
      buyAmount: this.sourceAmount,
      buycurrency: this.selectedDestination.id,
      pgamount: this.totalAmountToBePaid,
      source_currency: this.selectedSource.id
    }

    this.commonService.showLoader()
    this.buyCoinService.postBuyTransaction(buyTransObject).subscribe((res:any) => {
      if(res.id){
        this.transactionId = res.id
        // let psiObject = {
        //   StoreKey: environment.PSI_STORE_KEY_CC,
        //   SubTotal: this.totalAmountToBePaid,
        //   Email: this.authService.user.email,
        //   PaymentType: 'CC',
        //   CardAction: 0,
        //   CustomerRefNo: res.id
        // }
        // this.buyCoinService.postToPsi(psiObject)
        document.getElementById("psiFormButton").click()
      }
      this.commonService.hideLoader()
    }, (err:any) => {
      console.log(err)
      this.commonService.hideLoader()
    })
  }
}
